// Import the toast from sonner
import { toast as sonnerToast } from "sonner";

type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "destructive" | "success";
  duration?: number;
};

// Create our own useToast hook that returns an object with a toast method
export function useToast() {
  return {
    toast: (props: ToastProps | string) => {
      // Handle both object and string formats
      if (typeof props === "string") {
        return sonnerToast(props);
      }

      if (props.variant === "destructive") {
        return sonnerToast.error(props.title || "", {
          description: props.description,
          duration: props.duration,
          className: "android-toast",
          dismissible: true,
        });
      }

      if (props.variant === "success") {
        return sonnerToast.success(props.title || "", {
          description: props.description,
          duration: props.duration,
          className: "android-toast",
          dismissible: true,
        });
      }

      return sonnerToast(props.title || "", {
        description: props.description,
        duration: props.duration,
        className: "android-toast",
        dismissible: true,
      });
    },
    // Add a dummy toasts array to match the expected API
    toasts: [],
  };
}

// Export a simplified toast function that works like sonner's toast
export const toast = (props: ToastProps | string) => {
  const { toast } = useToast();
  return toast(props);
};

// Also export the direct methods for convenience
toast.success = sonnerToast.success;
toast.error = sonnerToast.error;
toast.warning = sonnerToast.warning;
toast.info = sonnerToast.info;
